<div>
  <div>{{ label() }}</div>
  <div>{{ value() }}</div>
</div>